import { render, staticRenderFns } from "./client-information.vue?vue&type=template&id=5a1e853a&"
import script from "./client-information.vue?vue&type=script&lang=ts&"
export * from "./client-information.vue?vue&type=script&lang=ts&"
import style0 from "./client-information.vue?vue&type=style&index=0&id=5a1e853a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports